import {useCallback} from 'react';
import {WebFrame} from 'interface/base/WebFrame';
import {getHost, isUpsellDeniedPlatform} from 'utils/platform';
import {useModal} from 'extensions/viewport/useModal';
import {WebViewMessageEvent} from 'react-native-webview';

type Plans = 'pro' | 'biz';
type Features = 'filedrop' | 'password' | 'bulkdownload' | 'webupload' | 'one_time_link';

export function useModalUpsellFeature(plan: Plans, feature: Features) {
  const modal = useModal();
  const exit = useCallback(() => modal.exit(), []);

  const message = useCallback((e: WebViewMessageEvent) => {
    if (e && e.nativeEvent.data === 'mf-close-dialogs') {
      exit();
    }
  }, []);

  const show = useCallback(() => {
    if (isUpsellDeniedPlatform()) return;
    const path = `${getHost()}/widgets/premium_upsell.php`;
    const query = `plan=${plan}&event=${feature}`;
    modal.open(
      <WebFrame url={`${path}?${query}`} exit={exit} onMessage={message}/>,
      {frameless: true},
    );
  }, [plan, feature]);

  return [show, exit];
}
